import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../hooks";
import { getStores } from "../slices/storeSlice";

export const useStores = () => {
    const dispatch = useAppDispatch();
    const { stores, loading, error, success, adding } = useAppSelector((state) => state.stores);

    useEffect(() => {
        if (!stores || stores.length === 0) {
            dispatch(getStores());
        }
    }, [dispatch]);

  return { stores, loading, error, success, adding };
};